// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProdCat_importCsvCard__K+4kB","addProdCatBtnContainer":"AddProdCat_addProdCatBtnContainer__TMbgC"};